<template>
    <div class="custom-file">
        <label class="custom-file-label"  for="customFile">{{ element.text }}</label>
        <input id="customFile" type="file" class="custom-file-input" :placeholder="element.placeholder">
    </div>
</template>

<script>
    export default {
        name: "FileInputElementPreview",
        props: {
            element: {
                type: Object
            }
        }
    }
</script>

<style scoped>

</style>
